import { Section } from '@rumblefish/ui/Rumblefish23Theme';
import {
  StyledFirstTitle,
  StyledList,
  StyledListItem,
  StyledServiceItem,
  StyledServiceTitle,
  StyledStack,
  StyledTwoTitles,
} from './styles';
import { whoThisIsForData } from './WhoThisIsFor.data';

export const WhoThisIsFor = () => {
  return (
    <Section width="small">
      <StyledStack>
        <StyledTwoTitles>
          <StyledFirstTitle variant="display_sm">
            {whoThisIsForData.title}
          </StyledFirstTitle>
        </StyledTwoTitles>

        <StyledList>
          {whoThisIsForData.items.map((data, index) => (
            <StyledListItem key={index}>
              <StyledServiceItem>
                <StyledServiceTitle variant="regular_500">
                  {data.title}
                </StyledServiceTitle>
              </StyledServiceItem>
            </StyledListItem>
          ))}
        </StyledList>
      </StyledStack>
    </Section>
  );
};
